import React, { useEffect, useState ,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWebsiteData  } from "../../redux/actions/settingsAcions";
import notify from "../../hook/useNotification";
import {
  getOneUser,
  getAllUsers,
  updateUser,
} from "../../redux/actions/usersActions";
import { getVendorByusername } from "../../redux/actions/vendorActions";
import avatar from "../../Images/avatar.png";
import { useTranslation } from "react-i18next";


const AdminEditUserHook = (id) => {
  const { t } = useTranslation();
  const [img, setImg] = useState(avatar);
  const [selectedFile, setSelectedFile] = useState(null);

  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState();
  const [loading, setLoading] = useState(true);
  const [loadingData, setLoadingData] = useState(true);
  const [userType, setUserType] = useState("");
  const [userName,setUserName] = useState("");
  const [usernameExists, setUsernameExists] = useState();
  const [usernameLoading, setUsernameLoading] = useState(true);
  const [checkLoading, setcheckLoading] = useState(false);

  const newEmailRef=useRef(false);
  const newMobileRef=useRef(false);

  const dispatch = useDispatch();

  const onChangeuserType= (e) => {
    e.persist();
    setUserType(e.target.value);
  };
  const onChangeFirstname = (e) => {
    e.persist();
    setFirstname(e.target.value);
  };
  const onChangeLastname = (e) => {
    e.persist();
    setLastname(e.target.value);
  };
  const onChangeEmail = (e) => {
    e.persist();
    setEmail(e.target.value);
  };
  const onChangeStatus = (e) => {
    e.persist();
    setStatus(e.target.value);
  };
  const onChangeMobile = (e) => {
    e.persist();
    setMobile(e.target.value);
  };

  const onChangeUsername = async (e) => {

    setUsernameExists(); 
    e.persist();
    setUserName(e.target.value)
    

    // const handler = setTimeout(async() => {
    //  // setDebouncedUserName(userName);
    //  setcheckLoading(true);
    //  setUsernameLoading(true);
    // await dispatch(getVendorByusername(e.target.value));
    // setUsernameLoading(false);
    //  setcheckLoading(false);

    // }, 500);

    // handler();

    //  clearTimeout(handler);    


   
  };

  const checkUser=async()=>{
     // setDebouncedUserName(userName);
     if(oneUser?.username===userName){
       setUsernameExists(false);
       return;
     }
     setcheckLoading(true);
     setUsernameLoading(true);
    await dispatch(getVendorByusername(userName));
    setUsernameLoading(false);
     setcheckLoading(false); 
  }

  const vendorByusername = useSelector(
    (state) => state.vendorReducer.vendorByUsername
  );

  useEffect(() => {
     if (usernameLoading === false) {
      console.log('vendorByusername',vendorByusername);
      if (vendorByusername && vendorByusername?._id) {
        setUsernameExists(true)
      } else {
        setUsernameExists(false)
      }
     }
  }, [usernameLoading]);


  const oneUser = useSelector((state) => state.usersReducers.oneUser);

  useEffect(() => {
    const get = async () => {
      setLoadingData(true);
      await dispatch(getOneUser(id));
      setLoadingData(false);
    };
    get();
  }, []);
  const webSiteData = useSelector((state) => state.settingsReducers.webSiteData);
  useEffect(() => {
    if (oneUser) {
      setFirstname(oneUser.firstname);
      setLastname(oneUser.lastname);
      setMobile(oneUser.mobile);
      setEmail(oneUser.email);
      setStatus(oneUser.status);
      setUserType(oneUser.role);
      setUserName(oneUser?.username);
      newEmailRef.current=oneUser?.email;
      newMobileRef.current=oneUser?.mobile;
      setImg(oneUser?.image);
    }
  }, [loadingData]);

  const res = useSelector((state) => state.usersReducers.updateUser);

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]){
      const file = event.target.files[0];
      const maxSize = 1 * 1024 * 1024; // 2 MB in bytes
        if (file.size > maxSize) {
            return alert(`Image size exceeds 1 MB`);
        }

      setImg(URL.createObjectURL(event.target.files[0]));
    setSelectedFile(event.target.files[0]);
    }
  };

  const onSubmit = async () => {

      if (firstname === "") {
      notify(t("enter first name"), "error");
      return;
    }
    if (lastname === "") {
      notify(t("enter last name"), "error");
      return;
    }
    if (email === "") {
      notify(t("enter email"), "error");
      return;
    }
    if (mobile === "") {
      notify(t("enter phone"), "error");
      return;
    }
    if (mobile.length < 9) {
      notify(t("enter phone"), "error");
      return;
    }
    
  if (userType === "" || userType === "0") {
      notify(t("select gender"), "error")
      return;
    }
    console.log('userName')
    console.log(userType)
    console.log(userName)
    if (userType === "vendor" && (!userName || userName === "")) {
      notify(t("add vendor name"), "error")
      return;
    }
    if (usernameExists == true) {
      notify(t("select user name"), "error")
      return;
    }
    if (lastname === "") {
      notify(t("enter last name"), "error");
      return;
    }
    if (email === "") {
      notify(t("enter email"), "error");
      return;
    }
    if (mobile === "") {
      notify(t("enter phone"), "error");
      return;
    }
    if (mobile.length < 9) {
      notify(t("enter phone"), "error");
      return;
    }
    
  if (userType === "" || userType === "0") {
      notify(t("select gender"), "error")
      return;
    }
    console.log('userName')
    console.log(userType)
    console.log(userName)
    if (userType === "vendor" && (!userName || userName === "")) {
      notify(t("add vendor name"), "error")
      return;
    }
    if (usernameExists == true) {
      notify(t("select user name"), "error")
      return;
    }
    setLoading(true);

    let updateUserObj={
      firstname: firstname,
      lastname: lastname,
      status: status,
      role:userType,
      username: userName
    }

    if(newEmailRef.current!=email) updateUserObj.email=email;
    if(newMobileRef.current!=mobile) updateUserObj.mobile=mobile;

    if(selectedFile) updateUserObj.image=selectedFile;
    
    await dispatch(
      //newEmailRef.current
      updateUser(id,updateUserObj)
    );
    setLoading(false);
  };

  useEffect(() => {
    if (loading === false) {
      console.log('res',res);

if (res?.data && res?.data?.success == true) {
        notify(t("product added successfully"), "success");
      } else {
        notify(t("product update failed"), "error");
      }
      newEmailRef.current=false;
    }
  }, [loading]);

  return [
    firstname,
    lastname,
    mobile,
    email,
    status,
    onChangeFirstname,
    onChangeLastname,
    onChangeEmail,
    onChangeStatus,
    onChangeMobile,
    onSubmit,
    userType,
    onChangeuserType,
    webSiteData,
    userName,
    onChangeUsername,
    usernameExists,
    checkLoading,
     img,
    onImageChange,
    checkUser
  ];
};

export default AdminEditUserHook;
